import React from 'react';
import { TypedMemo } from '../../../common/types';
import { SMLImage } from '../SMLImage';
import styles from './SharePubliclyPreviewCover.module.scss';

// The display width of the cover in CSS pixels. It agrees with `.previewCover`.
const PREVIEW_COVER_WIDTH = 56;

interface SharePubliclyPreviewCoverProps {
  /** Image of the shared artist, track or playlist. */
  coverUrl?: string;
  /** Entity name. Its first letter is the fallback when there is no image. */
  name: string;
}

const SharePubliclyPreviewCoverComponent: React.FC<SharePubliclyPreviewCoverProps> = ({ coverUrl, name }) => {
  if (coverUrl === undefined || coverUrl === '') {
    const initial = (name.trim().slice(0, 1) || 'M').toUpperCase();
    return (
      <div className={styles.previewCoverFallback} aria-hidden>
        {initial}
      </div>
    );
  }

  // SMLImage sends a storage image through imgproxy, as the page header does.
  // The content security policy blocks the raw storage URL, so a plain <img>
  // showed a broken image here.
  return (
    <SMLImage
      src={coverUrl}
      alt={name}
      width={PREVIEW_COVER_WIDTH}
      makeSquareFit
      className={styles.previewCover}
      loading="lazy"
    />
  );
};

export const SharePubliclyPreviewCover = TypedMemo(SharePubliclyPreviewCoverComponent);
